import type { ContactOrderStep } from "../../../../../../../api/kehrblatt/contact-orders"

/** Enrich only the explicitly selected point while its owner and address still match.
 * A changed registry point must not relabel the destination frozen in the plan.
 */
export const resolvePlannedContactPoint = (
  step: ContactOrderStep,
  contactPointById: Record<string, ContactPoint>,
): ContactPoint | null => {
  const pointId =
    step.channel === "LETTER" ? step.postal_contact_point_id : step.destination?.contact_point_id

  if (!pointId || !step.recipient_customer_id) return null

  const point = contactPointById[pointId]

  if (!point || point.customer_id !== step.recipient_customer_id) return null

  const expectedKinds =
    step.channel === "LETTER"
      ? ["ADDRESS"]
      : step.destination?.kind === "EMAIL"
        ? ["EMAIL"]
        : ["MOBILE", "FIXED_LINE"]

  if (!expectedKinds.includes(point.kind)) return null

  if (step.destination && (point.normalized_value || point.value) !== step.destination.value)
    return null

  return point
}
